import React from 'react';
import closeIcon from '../../static/close.svg';
import './feedback-survey-popup.scss';
function Surveypopup(props) {
    return (
        <div className={"hamburger-menu-container "+ (props.surveyVisible ? "visible" : "")}>
                    {/* <div className="feedbackButton" onClick={() => this.setState({ surveyVisible: !this.state.surveyVisible })} > */}
                    <div className="feedbackButton" onClick={props.onSurveyPopUpClick} >
                    <span> Powered by Litmus7 </span>
                    </div>
        </div>
    );
}
  
export default Surveypopup;